<ion-content [scrollY]="false">
    <div class="main-body" [ngClass]="{ 'scale': Ready && view.CanZoom }">
        <ng-container *ngIf="HasMenu === true">
            <ion-menu #mnmenu id="mnmenu" side="start" menuId="main" contentId="content-main-menu">
                <ng-content select="upp-application-menu"></ng-content>
            </ion-menu>
            <ion-nav #ionnav id="content-main-menu">
                <ng-content select="upp-application-main"></ng-content>
            </ion-nav>    
        </ng-container>
        <ng-container *ngIf="HasMenu !== true">
            <ng-content></ng-content>
        </ng-container>
    </div>
</ion-content>    
